<div class="mt-3">
  <div class="mb-3">
    <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
      <i class="fa fa-plus"></i> Add Item
    </button>
  </div>
  <table class="table table-responsive-sm table-hover table-outline mb-0">
    <thead class="thead-light">
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>IAP ID</th>
        <th>Price</th>
        <th>Rewards</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (isLoading) {
        <tr>
          <td colspan="7" class="text-center">
            <span class="spinner-border spinner-border-sm"></span> Loading...
          </td>
        </tr>
      } @else {
        @for (item of items; track item.itemId; let i = $index) {
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ item.name }}</td>
            <td><code>{{ item.iapId }}</code></td>
            <td>{{ item.price | number:'1.2-2' }} €</td>
            <td>{{ item.rewards.length }}</td>
            <td>
              @if (item.isPack) {
                <span class="badge bg-info">Pack</span>
              }
            </td>
            <td>
              <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(item)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
              <span class="text-muted mx-1">|</span>
              <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(item)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

<app-shop-item-add-modal #addModal></app-shop-item-add-modal>
<app-shop-item-edit-modal #editModal></app-shop-item-edit-modal>
